export default {
  computed: {
    proxied() {
      return this.$store.getters["proxy/isProxied"];
    }
  }
};
